(function () {
  'use strict';

  var CONFIG_ID = 'mmaCaptureExperimentConfig';

  function parseConfig() {
    var node = document.getElementById(CONFIG_ID);
    if (!node) return {};
    try {
      return JSON.parse(node.textContent || '{}');
    } catch (error) {
      return {};
    }
  }

  function storageGet(key) {
    try { return window.localStorage.getItem(key); } catch (error) { return null; }
  }

  function storageSet(key, value) {
    try {
      window.localStorage.setItem(key, value);
      return true;
    } catch (error) {
      return false;
    }
  }

  function sessionGet(key) {
    try { return window.sessionStorage.getItem(key); } catch (error) { return null; }
  }

  function sessionSet(key, value) {
    try { window.sessionStorage.setItem(key, value); } catch (error) { /* no-op */ }
  }

  function randomId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return 'capture-' + window.crypto.randomUUID();
    }
    return 'capture-' + Date.now() + '-' + Math.random().toString(36).slice(2, 12);
  }

  function randomUnit() {
    if (window.crypto && typeof window.crypto.getRandomValues === 'function') {
      var values = new Uint32Array(1);
      window.crypto.getRandomValues(values);
      return values[0] / 4294967296;
    }
    return Math.random();
  }

  function cookieGet(name) {
    var prefix = encodeURIComponent(name) + '=';
    var row = document.cookie.split('; ').find(function (item) { return item.indexOf(prefix) === 0; });
    return row ? decodeURIComponent(row.slice(prefix.length)) : '';
  }

  function cookieSet(name, value, days) {
    var secure = window.location.protocol === 'https:' ? '; Secure' : '';
    document.cookie = encodeURIComponent(name) + '=' + encodeURIComponent(value) +
      '; Path=/; Max-Age=' + String(Number(days || 120) * 86400) + '; SameSite=Lax' + secure;
  }

  function isQaContext(params) {
    return /^(localhost|127\.0\.0\.1|0\.0\.0\.0)$/i.test(window.location.hostname) ||
      Boolean(window.Shopify && window.Shopify.designMode) ||
      params.has('preview_theme_id');
  }

  function validAssignment(value, config) {
    if (!value || value.experimentName !== config.experimentName || value.allocationVersion !== config.allocationVersion) return false;
    return config.variants.some(function (variant) { return variant.id === value.variant; });
  }

  function migratePausedBlackjackSuppression(value, config) {
    var scratchOnly = config.variants.some(function (variant) {
      return variant.id === 'scratch_control' && Number(variant.weight || 0) > 0;
    }) && config.variants.every(function (variant) {
      return variant.id === 'scratch_control' || Number(variant.weight || 0) <= 0;
    });
    if (!scratchOnly || !value || value.variant !== 'blackjack_v1' || value.allocationVersion === config.allocationVersion) return;

    var blackjackSessionOpenedAt = sessionGet('mma_blackjack_session_opened_at');
    if (blackjackSessionOpenedAt && !sessionGet('mma_scratch_popup_session_opened_at')) {
      sessionSet('mma_scratch_popup_session_opened_at', blackjackSessionOpenedAt);
    }

    var blackjackDismissedAt = Number(storageGet('mma_blackjack_dismissed_at') || 0);
    var scratchDismissedAt = Number(storageGet('mma_scratch_popup_dismissed_at') || 0);
    if (blackjackDismissedAt > scratchDismissedAt) {
      storageSet('mma_scratch_popup_dismissed_at', String(blackjackDismissedAt));
    }

    var blackjackClaimedAt = storageGet('mma_blackjack_claimed_at');
    if (blackjackClaimedAt && !storageGet('mma_scratch_popup_submitted_at')) {
      storageSet('mma_scratch_popup_submitted_at', blackjackClaimedAt);
    }
  }

  function chooseVariant(variants) {
    var draw = randomUnit() * variants.reduce(function (sum, variant) { return sum + Number(variant.weight || 0); }, 0);
    var cursor = 0;
    for (var i = 0; i < variants.length; i += 1) {
      cursor += Number(variants[i].weight || 0);
      if (draw < cursor) return variants[i].id;
    }
    return variants[variants.length - 1].id;
  }

  function dispatchGa4Event(name, params, measurementId) {
    var payload = Object.assign({}, params || {});
    if (measurementId) payload.send_to = measurementId;

    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () {
      window.dataLayer.push(arguments);
    };
    window.gtag('event', name, payload);
  }

  function dispatchAssignment(assignment, config) {
    var payload = {
      event: 'mma_capture_experiment_assignment',
      experiment_name: config.experimentName,
      experiment_variant: assignment.variant,
      capture_experience: assignment.variant === 'blackjack_v1' ? 'blackjack_v1' : 'scratch_randomizer_control',
      allocation_version: config.allocationVersion,
      capture_assignment_id: assignment.assignmentId,
      assigned_at: assignment.assignedAt,
      page_type: config.pageType,
      page_path: config.pagePath || window.location.pathname
    };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    dispatchGa4Event(payload.event, {
      experiment_name: payload.experiment_name,
      experiment_variant: payload.experiment_variant,
      capture_experience: payload.capture_experience,
      allocation_version: payload.allocation_version,
      capture_assignment_id: payload.capture_assignment_id,
      page_type: payload.page_type,
      page_path: payload.page_path
    }, config.ga4MeasurementId);
    document.dispatchEvent(new CustomEvent('mma:capture-experiment-assigned', { detail: payload }));
  }

  var config = Object.assign({
    experimentName: 'capture_challenger_2026q3',
    allocationVersion: 'v2-scratch-only-20260923',
    storageKey: 'mma_capture_challenger_2026q3_assignment_v1',
    cookieName: 'mma_capture_challenger_2026q3',
    persistenceDays: 120,
    ga4MeasurementId: 'G-PKHVJ3LX7Z',
    pageType: 'unknown',
    pagePath: window.location.pathname,
    variants: [
      { id: 'scratch_control', weight: 100 },
      { id: 'blackjack_v1', weight: 0 }
    ]
  }, parseConfig());

  var params = new URLSearchParams(window.location.search || '');
  var qa = isQaContext(params);
  if (qa && params.get('mma_capture_reset') === '1') {
    storageSet(config.storageKey, '');
    cookieSet(config.cookieName, '', -1);
  }

  var assignment = null;
  var stored = storageGet(config.storageKey) || cookieGet(config.cookieName);
  if (stored) {
    try { assignment = JSON.parse(stored); } catch (error) { assignment = null; }
  }
  migratePausedBlackjackSuppression(assignment, config);

  var forcedVariant = qa ? params.get('mma_capture_variant') : '';
  if (forcedVariant && config.variants.some(function (variant) { return variant.id === forcedVariant; })) {
    assignment = null;
  }

  if (!validAssignment(assignment, config)) {
    assignment = {
      experimentName: config.experimentName,
      allocationVersion: config.allocationVersion,
      assignmentId: randomId(),
      assignedAt: new Date().toISOString(),
      variant: forcedVariant || chooseVariant(config.variants)
    };
    var encoded = JSON.stringify(assignment);
    storageSet(config.storageKey, encoded);
    cookieSet(config.cookieName, encoded, config.persistenceDays);
  }

  window.MmaCaptureExperiment = {
    ready: true,
    experimentName: config.experimentName,
    allocationVersion: config.allocationVersion,
    assignmentId: assignment.assignmentId,
    assignedAt: assignment.assignedAt,
    variant: assignment.variant,
    shouldRun: function (variant) { return assignment.variant === variant; }
  };
  document.documentElement.setAttribute('data-mma-capture-variant', assignment.variant);

  var sessionEventKey = config.storageKey + '_' + config.allocationVersion + '_event_sent';
  if (!sessionGet(sessionEventKey)) {
    sessionSet(sessionEventKey, '1');
    dispatchAssignment(assignment, config);
  }
}());
